import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { csvDownload } from '../csv-download';
import { excelDownload } from '../excel-download';
import Pagination from '../pagination';
import { SaleAction } from '../../store/actions';

class SaleData extends PureComponent {
  static propTypes = {
    getSales: PropTypes.func,
    location: PropTypes.object,
    sales: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      path: '/a/report/sale-data',
      per_page: 250,
      sold_at_end: '',
      sold_at_start: '',
    };
  }

  componentDidMount() {
    const params = {
      ...Object?.fromEntries?.(
        new URLSearchParams(this.props.location?.search),
      ),
      path: this.state.path,
      per_page: this.state.per_page,
    };
    this.props.getSales?.(params);
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onDownload(type) {
    const download = [
      type === 'csv' && csvDownload,
      type === 'excel' && excelDownload,
    ].find(i => i);
    download?.(
      [
        'Sl No',
        'Dealer Name',
        'Branch',
        'Customer Name',
        'Mobile',
        'Model',
        'Color',
        'Sale Date',
        'Chassis No',
        'Engine No',
      ],
      this.props.sales?.data,
      (r, i) => [
        i + 1,
        r.office?.name,
        '',
        r.customer?.name,
        r.customer?.mobile_number,
        r.purchase?.vehicle?.model,
        r.purchase?.color?.name,
        r.sold_at,
        r.purchase?.chassis_number?.slice?.(-5),
        r.purchase?.engine_number?.slice?.(-5),
      ],
      'SALE-DATA-REPORT',
    );
  }

  onSearch() {
    const { path, per_page, sold_at_end, sold_at_start } = this.state;
    if (!(sold_at_end && sold_at_start)) {
      return;
    }
    const params = {
      ...Object?.fromEntries?.(
        new URLSearchParams(this.props.location?.search),
      ),
      path,
      per_page,
      query: `sold_at_range:${sold_at_start},${sold_at_end}`,
    };
    this.props.getSales?.(params);
  }

  render() {
    const {
      getSales = () => {},
      location = {},
      sales: { data: sales = [], links = [] } = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Sale Data</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getSales}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '350px' }}
                >
                  <div className="input-group-prepend">
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => this.onDownload('excel')}
                      type="button"
                    >
                      <i className="fas fa-file-excel"></i>
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => this.onDownload('csv')}
                      type="button"
                    >
                      <i className="fas fa-file-csv"></i>
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={this.onSearch.bind(this)}
                      type="button"
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                  <input
                    className="form-control"
                    name="sold_at_start"
                    onChange={this.onChange.bind(this)}
                    type="date"
                  />
                  <input
                    className="form-control"
                    name="sold_at_end"
                    onChange={this.onChange.bind(this)}
                    type="date"
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0 table-responsive">
              {sales?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {sales?.length > 0 && (
                <table className="small table table-sm table-striped text-nowrap">
                  <thead>
                    <tr>
                      <th>Sl No</th>
                      <th>Dealer Name</th>
                      <th>Branch</th>
                      <th>Customer Name</th>
                      <th>Mobile</th>
                      <th>Model</th>
                      <th>Color</th>
                      <th>Sale Date</th>
                      <th>Chassis No</th>
                      <th>Engine No</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sales?.map?.((row, i) => (
                      <tr key={row.id}>
                        <td>{i + 1}</td>
                        <td>{row.office?.name}</td>
                        <td>&nbsp;</td>
                        <td>{row.customer?.name}</td>
                        <td>{row.customer?.mobile_number}</td>
                        <td>{row.purchase?.vehicle?.model}</td>
                        <td>{row.purchase?.color?.name}</td>
                        <td>{row.sold_at}</td>
                        <td>{row.purchase?.chassis_number?.slice?.(-5)}</td>
                        <td>{row.purchase?.engine_number?.slice?.(-5)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sales: state?.sale?.list,
});

const mapDispatchToProps = dispatch => ({
  getSales: params => dispatch(SaleAction.getSales(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SaleData);
